import I18n from 'i18n-js';
import React from 'react';
import { DEFAULT_CONDITION, MARKETPLACE_PATH } from '../shared/constants';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import EMPTY_STATE_IMAGE from '../../../images/icons/empty-states/no-listings@2x.png';
import { Core_Shop_MarketplaceQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

interface Props {
  shop: Core_Shop_MarketplaceQuery['shop'];
}

function NoSearchResults(props: { query: object }) {
  return (
    <section className="align-center scaling-padding-8">
      <img
        src={EMPTY_STATE_IMAGE}
        className="mlr-auto mobile-width-70"
        alt={I18n.t('discovery.emptyShop.noListings')}
      />
      <h2 className="cms-h2">
        {I18n.t('discovery.emptyShop.nothingInShopMatchingSearch')}
      </h2>
      <CoreLink
        to={{
          pathname: `/${MARKETPLACE_PATH}`,
          query: props.query,
        }}
        className="icon-r-arrow-right weight-bold"
      >
        {I18n.t('discovery.emptyShop.expandSearchToAllShops')}
      </CoreLink>
    </section>
  );
}

function ShopHasNoListings() {
  return (
    <section className="align-center scaling-padding-8">
      <img
        src={EMPTY_STATE_IMAGE}
        className="mlr-auto mobile-width-70"
        alt={I18n.t('discovery.emptyShop.noListings')}
      />
      <h2 className="cms-h2">
        {I18n.t('discovery.emptyShop.shopHasNoListings')}
      </h2>
      <a href="/shops" className="button button--primary">
        {I18n.t('discovery.emptyShop.seeTopShops')}
      </a>
    </section>
  );
}

function VacationMode(props: { shopName: string }) {
  return (
    <section className="align-center scaling-padding-8">
      <div data-vacation-message className="site-wrapper site-wrapper--cms">
        <div className="bg-white bd-1 bd-primary standard-shadow mb-8 align-center scaling-padding-8">
          <h3 className="cms-h1 mt-0">
            {I18n.t('discovery.emptyShop.vacation.title', { name: props.shopName })}
          </h3>
          <h4 className="cms-h3">
            {I18n.t('discovery.emptyShop.vacation.subtitle')}
          </h4>
        </div>
      </div>
    </section>
  );
}

function ShopOwnerShop() {
  return (
    <section className="align-center scaling-padding-8">
      <h2 className="cms-h2">
        {I18n.t('discovery.emptyShop.yourShopIsEmpty')}
      </h2>
      <a
        href="/sell"
        className="button button--primary"
      >
        {I18n.t('discovery.emptyShop.listAnItem')}
      </a>
    </section>
  );
}

export function EmptyShop(props: Props) {
  const url = useURL();
  const user = useUser();

  if (props.shop.onVacation) {
    return <VacationMode shopName={props.shop.name} />;
  }

  const { condition = DEFAULT_CONDITION, ...otherFilters } = url.query;
  const isFiltering = condition !== DEFAULT_CONDITION || Object.keys(otherFilters).length > 0;
  if (isFiltering) {
    return <NoSearchResults query={url.query} />;
  }

  const isShopOwner = String(user.id) === props.shop.userId;
  if (isShopOwner) {
    return <ShopOwnerShop />;
  }

  return <ShopHasNoListings />;
}
